import XesLogger from '@xes/xes_fe_log';
const initLogger = (options) => {
    console.log(options,'options')
    new XesLogger({
        uv:  options?.talId || '',
        common: {
            eventid:'sea_parent_webapp',
        },
        appid: '20241118',
        disableAgif: true, // 关闭展现日志上传(a.gif)
        clickMsg: { open: false }, // 关闭交互日志上传(b.gif)
        loadMsg: {
            open: true,
        },
        pvMsg: {
            open: true,
        },
        runtime: {
            open: true,
        },
        network: {
            open: true,
            stopAbortLog: true,
        },
        performance: {
            open: true,
        },
        hashchange: {
            open: true,
            pvid: 'hash',
        },
        xLogReferer: options?.env === 'pro' ? 'webapp.thinkbuddy.com' : 'webapp-test.chengjiukehu.com',
        baseURL: options?.env === 'pro' ? 'https://dj.thinkbuddy.com/20241118/': 'https://dj-test.xesimg.com/20241118/',
        param: {
            talId: options?.talId || '',
            userId: options?.talId || '',
        },
    });
}

export default initLogger;
